export default {
    methods: {
        openWeb720 () {
            const { vr_panorama_resource } = this.house
            if (vr_panorama_resource && vr_panorama_resource.vr_panorama_url) {
                window.open(vr_panorama_resource.vr_panorama_url)
            }
        }
    }
}